import { cn } from "@newxsystems/shared";
import { WohaCardLink } from "../../../../modules/content/components/WohaCardLink/WohaCardLink";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaMedia } from "../../../../modules/content/components/WohaMedia/WohaMedia";
import { WohaRichText } from "../../../../modules/content/components/WohaRichText/WohaRichText";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { ITestimonialGridBlockProps } from "./TestimonialGridBlock.props";
const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
const spans = {
  1: "lg:col-span-1",
  2: "lg:col-span-2",
  3: "lg:col-span-3",
  4: "lg:col-span-4",
} as const;
const surfaces = ["bg-soft-blue", "bg-paper-mist", "bg-soft-violet"] as const;
export const TestimonialGridBlock = ({
  alignment,
  anchorId,
  buttons,
  columnCount,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
}: ITestimonialGridBlockProps) => {
  if (!items?.length) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-12">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className={cn("grid grid-cols-1 gap-4 sm:grid-cols-2", columns[columnCount || 3])}>
          {items.map((item, index) => (
            <WohaCardLink
              className={cn(
                "flex flex-col justify-between border-0 p-7 md:p-8",
                surfaces[index % surfaces.length],
                spans[item.columnSpan || 1],
                columnCount === 3 || (columnCount === 4 && "min-h-72"),
              )}
              key={index}
              link={item.cardLink}
            >
              <WohaRichText
                className="font-satoshi text-xl font-medium leading-8 text-charcoal"
                content={item.quote}
              />
              <div className="mt-8 flex items-center gap-3">
                {item.portrait ? (
                  <WohaMedia
                    aspectRatio="1:1"
                    className="size-12 shrink-0 rounded-full"
                    media={item.portrait.image}
                    sizes="48px"
                  />
                ) : null}
                <div>
                  <p className="font-medium text-charcoal">{item.name}</p>
                  {item.attribution ? (
                    <p className="text-sm text-steel">{item.attribution}</p>
                  ) : null}
                </div>
              </div>
            </WohaCardLink>
          ))}
        </div>
      </div>
    </WohaSection>
  );
};
TestimonialGridBlock.displayName = "Block::TestimonialGridBlock";
